import type { ConfigSection } from '@/modules/projects/stores/caseConfig'

// The slice of the case config the report wizard interprets.
export interface SectionCatalog {
  sections: ConfigSection[]
  suggestedSections: Record<string, string[]>
}

export interface ReportConfigOptions {
  sections: ConfigSection[]
  allSectionsKeys: string[]
  pinnedSectionsKeys: string[]
  pinnedTopSections: ConfigSection[]
  pinnedTopSectionsKeys: string[]
  pinnedBottomSections: ConfigSection[]
  pinnedBottomSectionsKeys: string[]
  suggestedSections: Record<string, string[]>
}

// The wire orders the catalog with pinned runs at both ends; the top run stays
// above the user's picks and the bottom run below them.
export const deriveReportConfigOptions = (
  catalog: SectionCatalog,
): ReportConfigOptions => {
  const { sections } = catalog

  const pinnedTopSections: ConfigSection[] = []
  for (const section of sections) {
    if (!section.pinned) break
    pinnedTopSections.push(section)
  }

  const pinnedBottomSections: ConfigSection[] = []
  for (let i = sections.length - 1; i >= pinnedTopSections.length; i--) {
    if (!sections[i].pinned) break
    pinnedBottomSections.unshift(sections[i])
  }

  const pinnedTopSectionsKeys = pinnedTopSections.map(({ key }) => key)
  const pinnedBottomSectionsKeys = pinnedBottomSections.map(({ key }) => key)

  return {
    sections,
    suggestedSections: catalog.suggestedSections,
    allSectionsKeys: sections.map(({ key }) => key),
    pinnedSectionsKeys: [...pinnedTopSectionsKeys, ...pinnedBottomSectionsKeys],
    pinnedTopSections,
    pinnedTopSectionsKeys,
    pinnedBottomSections,
    pinnedBottomSectionsKeys,
  }
}
